import React from 'react'
import PropTypes from 'prop-types'
import { View, TouchableOpacity, StyleSheet, Dimensions } from 'react-native'
import Animated from 'react-native-reanimated'
import { useTheme } from '../../../theming/ThemeProvider'
import { usePlatforms } from '../../../hooks/usePlatforms'
import { Txt } from '../../../components'

const { width: WIDTH } = Dimensions.get('window')
const TopTabBarNavigation = ({
  state,
  descriptors, navigation, position
}) => {
  const { isTablet } = usePlatforms()
  const { theme } = useTheme()
  const styles = useStyles(theme, isTablet)
  const size = isTablet ? 350 : WIDTH

  const width = size / state?.routes.length || 0

  const inputRange = state.routes.map((_, i) => i)
  const translateX = Animated.interpolate(position, {
    inputRange,
    outputRange: inputRange.map(i => i === 0 ? 0 : i * width)
  })

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10 }}>
      <View style={[{
        flexDirection: 'row',
        position: 'relative',
        width: width * 2
      }]}
      >
        {state.routes.map((route, index) => {
          const { options } = descriptors[route.key]
          const label =
            options.tabBarLabel !== undefined
              ? options.tabBarLabel
              : options.title !== undefined
                ? options.title
                : route.name

          const isFocused = state.index === index
          const onPress = () => {
            const event = navigation.emit({
              type: 'tabPress',
              target: route.key,
              canPreventDefault: true
            })

            if (!isFocused && !event.defaultPrevented) {
              navigation.navigate(route.name)
            }
          }

          const onLongPress = () => {
            navigation.emit({
              type: 'tabLongPress',
              target: route.key
            })
          }

          return (
            <TouchableOpacity
              activeOpacity={0.8}
              accessibilityRole='button'
              accessibilityStates={isFocused ? ['selected'] : []}
              accessibilityLabel={options.tabBarTestID}
              testID={options.tabBarTestID}
              onPress={onPress}
              onLongPress={onLongPress}
              style={{ flex: 1 }}
              key={index}
            >
              <Txt
                text={label}
                style={styles.labelStyle}
                color={isFocused ? 'AZTEC' : 'SLATE_GRAY'}
                identity='body1Bold'
              />

            </TouchableOpacity>
          )
        })}
        <Animated.View
          style={[styles.indicatorStyle, {
            width,
            transform: [
              { translateX }
            ]
          }]}
        />
      </View>
    </View>
  )
}

const useStyles = (theme, isTablet) => StyleSheet.create({
  rowStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 25,
    marginBottom: 12

  },
  titleStyle: {
    fontWeight: 'bold',
    fontSize: 23,
    flex: 1
  },
  iconStyle: {
    marginHorizontal: 10
  },
  labelStyle: {
    paddingVertical: isTablet ? 0 : 15,
    textAlign: 'center'
  },
  indicatorStyle: {
    height: isTablet ? 2 : 3,
    backgroundColor: theme.AZTEC,
    position: 'absolute',
    bottom: 0
  },
  isActive: {
    fontWeight: 'bold',
    color: theme.AZTEC
  },
  search: {
    position: 'absolute',
    right: 0
  }
})

TopTabBarNavigation.defaultProps = {
  showSearch: true,
  searchEvents: []
}

TopTabBarNavigation.propTypes = {
  state: PropTypes.any,
  descriptors: PropTypes.any,
  navigation: PropTypes.any,
  position: PropTypes.any
}

export default TopTabBarNavigation
